// Shared Framer Motion variants & transitions — module-level constants to avoid
// creating new object references on every render (performance optimization).

export const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

export const stagger = {
  visible: { transition: { staggerChildren: 0.1 } }
};

// Hero-style entrance animations
export const HERO_EYEBROW = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { delay: 0.3 }
};

export const HERO_TITLE = {
  initial: { opacity: 0, y: 50 },
  animate: { opacity: 1, y: 0 },
  transition: { delay: 0.4, duration: 0.8 }
};

export const HERO_TITLE_EARLY = {
  initial: { opacity: 0, y: 50 },
  animate: { opacity: 1, y: 0 },
  transition: { delay: 0.3, duration: 0.8 }
};

export const HERO_SUB = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { delay: 0.5 }
};

export const HERO_SUB_LATE = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { delay: 0.7 }
};

export const HERO_CTA = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { delay: 0.9 }
};

// Chevron bounce
export const CHEVRON_BOUNCE = {
  animate: { y: [0, 10, 0] },
  transition: { repeat: Infinity, duration: 1.5 }
};

// In-view reveals (used with animate={isInView ? target : {}})
export const REVEAL_FROM_RIGHT = {
  initial: { opacity: 0, x: 50 },
  target: { opacity: 1, x: 0 },
  transition: { duration: 0.8, delay: 0.3 }
};

export const REVEAL_FROM_LEFT = {
  initial: { opacity: 0, x: -50 },
  target: { opacity: 1, x: 0 },
  transition: { duration: 0.8 }
};

export const REVEAL_FADE = {
  initial: { opacity: 0 },
  target: { opacity: 1 },
  transition: { duration: 0.8 }
};

export const REVEAL_UP = {
  initial: { opacity: 0, y: 30 },
  target: { opacity: 1, y: 0 },
  transition: { duration: 0.6 }
};

export const REVEAL_UP_DELAYED = {
  initial: { opacity: 0, y: 30 },
  target: { opacity: 1, y: 0 },
  transition: { duration: 0.6, delay: 0.3 }
};
